import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Press badges block — "Vu sur..." with logos.
 * Renders nothing if the admin has not added any badge yet.
 */
export default function PressBadges() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/press-badges`).then((r) => {
      setItems(r.data?.items || []);
    }).catch(() => {});
  }, []);

  if (!items.length) return null;

  return (
    <section className="py-12 border-y border-ink/10 bg-ivory-100" data-testid="press-badges-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <p className="text-xs uppercase tracking-[0.25em] text-ink/60 text-center mb-6">Ils parlent de nous</p>
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12 opacity-80">
          {items.map((b) => {
            const inner = b.logo_url ? (
              <img src={b.logo_url} alt={b.name} loading="lazy" decoding="async" className="h-8 md:h-10 w-auto object-contain grayscale hover:grayscale-0 transition" />
            ) : (
              <span className="font-display text-xl text-ink">{b.name}</span>
            );
            return b.link_url ? (
              <a key={b.id} href={b.link_url} target="_blank" rel="noopener noreferrer" data-testid={`press-badge-${b.id}`}>
                {inner}
              </a>
            ) : (
              <div key={b.id} data-testid={`press-badge-${b.id}`}>{inner}</div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
